export default "__VITE_ASSET__CPoLOGhJ__"